import React from 'react';
import { Button } from './Button';
import { Menu } from 'lucide-react';
interface NavbarProps {
  onNavigate?: (path: string) => void;
  hideInitiateAccess?: boolean;
}
export function Navbar({
  onNavigate,
  hideInitiateAccess
}: NavbarProps) {
  const handleNavigation = (path: string) => {
    if (onNavigate) {
      onNavigate(path);
    }
  };
  return <nav className="sticky top-0 z-50 w-full border-b border-dashed border-[#9ca3af] bg-white/90 backdrop-blur-sm" data-id="element-77">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8 gap-2" data-id="element-78">
        {/* Logo and Title - Responsive sizing */}
        <div className="flex items-center gap-2 sm:gap-4 cursor-pointer flex-shrink min-w-0" onClick={() => handleNavigation('/')} data-id="element-79">
          <img src="https://cdn.magicpatterns.com/uploads/a1ohPsjKDFpRBQVVygum9S/Logo_and_Teashirt_branding.png" alt="The Networking Salon" className="h-8 sm:h-12 w-auto flex-shrink-0" data-id="element-80" />
          <div className="min-w-0" data-id="element-81">
            <span className="font-bold text-xs sm:text-lg tracking-tight text-[#1f2933] block leading-tight truncate" data-id="element-82">
              THE AUTHORITY ENGINE
            </span>
            <span className="font-mono text-[7px] sm:text-[9px] text-[#9ca3af] block truncate" data-id="element-83">
              An initiative by The Networking Salon Ltd.
            </span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-8" data-id="element-84">
          <button onClick={() => handleNavigation('/')} className="font-mono text-xs text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-85">
            HOME
          </button>
          <button onClick={() => handleNavigation('/blueprint')} className="font-mono text-xs text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-86">
            BLUEPRINT
          </button>
          <button onClick={() => handleNavigation('/initiate-access#payment')} className="font-mono text-xs text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-87">
            JOIN
          </button>
          <button onClick={() => handleNavigation('/lounge')} className="font-mono text-xs text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-88">
            LOUNGE
          </button>
          <button onClick={() => handleNavigation('/sitemap')} className="font-mono text-xs text-[#9ca3af] hover:text-salon-red transition-colors flex items-center gap-1" title="View all pages" data-id="element-89">
            <Menu className="w-3 h-3" data-id="element-90" />
            PAGES
          </button>
        </div>

        {/* Right side buttons - Responsive */}
        <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0" data-id="element-91">
          <button onClick={() => handleNavigation('/affiliate')} className="hidden md:block font-mono text-xs text-[#1f2933] hover:text-salon-red transition-colors whitespace-nowrap" data-id="element-92">
            SIGNUP_AS_AFFILIATE
          </button>
          {!hideInitiateAccess && <Button variant="primary" size="small" onClick={() => handleNavigation('/initiate-access#payment')} className="bg-salon-red hover:bg-salon-red/90 border-salon-red text-[10px] sm:text-xs px-2 sm:px-4 whitespace-nowrap" data-id="element-93">
              INITIATE_ACCESS
            </Button>}
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <div className="lg:hidden border-t border-dashed border-[#9ca3af]/30 px-4 py-2 flex items-center justify-center gap-4 flex-wrap" data-id="element-94">
        <button onClick={() => handleNavigation('/')} className="font-mono text-[10px] text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-95">
          HOME
        </button>
        <button onClick={() => handleNavigation('/blueprint')} className="font-mono text-[10px] text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-96">
          BLUEPRINT
        </button>
        <button onClick={() => handleNavigation('/initiate-access#payment')} className="font-mono text-[10px] text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-97">
          JOIN
        </button>
        <button onClick={() => handleNavigation('/lounge')} className="font-mono text-[10px] text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-98">
          LOUNGE
        </button>
        <button onClick={() => handleNavigation('/affiliate')} className="font-mono text-[10px] text-[#1f2933] hover:text-salon-red transition-colors" data-id="element-99">
          AFFILIATE
        </button>
        <button onClick={() => handleNavigation('/sitemap')} className="font-mono text-[10px] text-[#9ca3af] hover:text-salon-red transition-colors flex items-center gap-1" data-id="element-100">
          <Menu className="w-3 h-3" data-id="element-101" />
          ALL_PAGES
        </button>
      </div>
    </nav>;
}